import { ProjectId } from '../../canvas/types';

export const generateId = (): ProjectId => `project_${Date.now()}` as ProjectId;

let counter = 0;

/** Process-unique id with the given prefix; survives same-tick collisions. */
export const generateUniqueId = (prefix: string): string => `${prefix}_${Date.now().toString(36)}_${++counter}`;
